class CinotonCollectionCompare extends HTMLElement {
  connectedCallback() {
    if (this.dataset.compareReady === 'true') return;
    this.dataset.compareReady = 'true';

    this.slots = [...this.querySelectorAll('[data-compare-slot]')];
    this.status = this.querySelector('[data-compare-status]');
    this.rail = this.querySelector('.cinoton-compare__rail');
    this.previousButton = this.querySelector('[data-compare-prev]');
    this.nextButton = this.querySelector('[data-compare-next]');
    this.activeSlotIndex = 0;

    this.slots.forEach((slot) => {
      const select = slot.querySelector('[data-compare-select]');
      if (!select) return;
      select.addEventListener('change', () => {
        this.showProduct(slot, true);
        this.syncOptions();
      });
      this.showProduct(slot, false);
    });

    this.syncOptions();
    this.setupMobileNavigation();
  }

  disconnectedCallback() {
    this.rail?.removeEventListener('scroll', this.handleRailScroll);
    window.removeEventListener('resize', this.handleRailResize);
    this.previousButton?.removeEventListener('click', this.handlePreviousClick);
    this.nextButton?.removeEventListener('click', this.handleNextClick);
    if (this.navigationFrame) cancelAnimationFrame(this.navigationFrame);
  }

  setupMobileNavigation() {
    if (!this.rail || !this.previousButton || !this.nextButton || this.slots.length < 2) return;

    this.handlePreviousClick = () => this.moveToSlot(this.activeSlotIndex - 1);
    this.handleNextClick = () => this.moveToSlot(this.activeSlotIndex + 1);
    this.handleRailScroll = () => {
      if (this.navigationFrame) cancelAnimationFrame(this.navigationFrame);
      this.navigationFrame = requestAnimationFrame(() => this.updateMobileNavigation());
    };
    this.handleRailResize = () => this.updateMobileNavigation();

    this.previousButton.addEventListener('click', this.handlePreviousClick);
    this.nextButton.addEventListener('click', this.handleNextClick);
    this.rail.addEventListener('scroll', this.handleRailScroll, { passive: true });
    window.addEventListener('resize', this.handleRailResize, { passive: true });
    this.updateMobileNavigation();
  }

  slotLeft(index) {
    return this.slots[index].offsetLeft - this.rail.offsetLeft;
  }

  updateMobileNavigation() {
    if (!this.rail || !this.previousButton || !this.nextButton) return;

    const currentLeft = this.rail.scrollLeft;
    this.activeSlotIndex = this.slots.reduce((closestIndex, slot, index) => {
      const closestDistance = Math.abs(this.slotLeft(closestIndex) - currentLeft);
      const slotDistance = Math.abs(this.slotLeft(index) - currentLeft);
      return slotDistance < closestDistance ? index : closestIndex;
    }, 0);

    this.previousButton.disabled = this.activeSlotIndex === 0;
    this.nextButton.disabled = this.activeSlotIndex === this.slots.length - 1;
  }

  moveToSlot(index) {
    const targetIndex = Math.max(0, Math.min(index, this.slots.length - 1));
    this.activeSlotIndex = targetIndex;
    this.previousButton.disabled = targetIndex === 0;
    this.nextButton.disabled = targetIndex === this.slots.length - 1;
    this.rail.scrollTo({
      left: this.slotLeft(targetIndex),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
    });

    if (this.status) {
      this.status.textContent = `Showing comparison column ${targetIndex + 1} of ${this.slots.length}.`;
    }
  }

  showProduct(slot, announce) {
    const select = slot.querySelector('[data-compare-select]');
    if (!select) return;

    slot.querySelectorAll('[data-compare-panel]').forEach((panel) => {
      const active = panel.dataset.comparePanel === select.value;
      panel.hidden = !active;
      panel.setAttribute('aria-hidden', String(!active));
    });

    if (announce && this.status) {
      const selectedOption = select.options[select.selectedIndex];
      const label = selectedOption?.dataset.fullTitle || selectedOption?.text || '';
      this.status.textContent = `Comparison column updated to ${label}.`;
    }
  }

  syncOptions() {
    const selections = this.slots.map((slot) => slot.querySelector('[data-compare-select]')?.value);
    this.slots.forEach((slot, slotIndex) => {
      const select = slot.querySelector('[data-compare-select]');
      if (!select) return;
      [...select.options].forEach((option) => {
        option.disabled = selections.some((value, index) => index !== slotIndex && value === option.value);
      });
    });
  }
}
if (!customElements.get('cinoton-collection-compare')) {
  customElements.define('cinoton-collection-compare', CinotonCollectionCompare);
}
